var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"be-wrapper be-fixed-sidebar"},[_c('nav_bar',{attrs:{"change_distribution":_vm.change_distribution}}),_c('menu_left')],1)}
var staticRenderFns = []

export { render, staticRenderFns }